import PageLoadedQueue from "../PageLoadedQueue";
import {getCookie, setCookie} from "../Plugins/Cookies";

class RecentlyViewedSidebar {

    protected sidebarElement: HTMLElement;
    protected triggerElement: HTMLElement;

    constructor(sidebarElement: HTMLElement) {

        this.sidebarElement = sidebarElement;
        this.triggerElement = sidebarElement.querySelector('.recently-viewed-sidebar__trigger');

        this.initializeListeners();
    }

    protected initializeListeners = () => {
        this.triggerElement?.addEventListener('click', (e) => {
            setCookie('recentlyViewedSidebarOpen', this.sidebarElement.classList.toggle('open'));
        });

        if (getCookie('recentlyViewedSidebarOpen') === 'true' || getCookie('recentlyViewedSidebarOpen') === '') {
            setTimeout(() => {
                this.sidebarElement.classList.add('open');
                this.sidebarElement.classList.add('ready');
            }, 300);
        } else {
            setTimeout(() => {
                this.sidebarElement.classList.add('ready');
            }, 50);
        }
    }

    static initializedElements: Map<HTMLElement, RecentlyViewedSidebar> = new Map();

    static initializeElement() {
        const sidebarElement: HTMLElement = document.querySelector('.recently-viewed-sidebar');
        if (!RecentlyViewedSidebar.initializedElements.has(sidebarElement)) {
            const sidebarElement: HTMLElement = document.querySelector('.recently-viewed-sidebar');
            if (sidebarElement) {
                this.initializedElements.set(sidebarElement, new RecentlyViewedSidebar(sidebarElement));
            }
        }
        return RecentlyViewedSidebar.initializedElements.get(sidebarElement);
    }

    static initialize() {
        RecentlyViewedSidebar.initializeElement();

        document.addEventListener('Plandent.StandalonePortal.Loaded', (e) => {
            RecentlyViewedSidebar.initializeElement();
        });
    }
}

PageLoadedQueue.addFunction(RecentlyViewedSidebar.initialize);
